// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"TermsOfService_pattern-gradient__cnKla","table":"TermsOfService_table__u-VIn","article":"TermsOfService_article__fhdhp"};